module.exports = "/_next/static/images/33c7171577413739fc067ae4d717082e-mgm-invite-ticket-3.jpg";